export enum JobType {
  TranscribePiano = 'piano2notes',
  TranscribeSinging = 'sing2notes',
  TranscribeGuitar = 'guitar2tabs',
  TranscribeDrums = 'drum2notes',
  TranscribeStudio = 'studio',
  TranscribeScan = 'scan2notes',
  TranscribeVST = 'ai2notes-vst',
  TranscribeWind = 'wind2notes',
  TranscribeViolin = 'violin2notes',
}

export enum SheetSourceType {
  Microphone = 'microphone',
  File = 'file',
  YouTube = 'youtube',
  Instagram = 'instagram',
  TikTok = 'tiktok',
}

export enum ExportType {
  PDF = 'pdf',
  MIDI = 'midi',
  MUSIC_XML = 'xml',
  MUSIC_JSON = 'json',
  GUITAR_PRO = 'gp5',
  PIANO_ROLL = 'piano_roll',
  UNQUANTIZED_MIDI = 'unquantized_midi',
  AUDIO_SYNTH = 'synth',
  AUDIO_ORIG = 'orig',
  MP3 = 'mp3',
  LILYPOND = 'ly',
}

export enum TranscriptionState {
  // Transcription was successful
  Ok = 'ok',
  // Minion is working on it
  Processing = 'processing',
  // Transcription is waiting for a Minion to start over
  Enqueued = 'enqueued',
  // Transcription was not successful
  Error = 'error',
  // Transcription was refunded
  Refunded = 'refunded',
}
